function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Id1",
  className: "body"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  className: "top",
  "data-name": "Path 86",
  d: "M1284.627 200.617v16.455a4.8 4.8 0 004.8 4.8h8.023a4.8 4.8 0 004.8-4.8v-16.455zm5.755 15.578a.958.958 0 11-1.916 0v-11.426a.958.958 0 111.916 0zm4.017 0a.958.958 0 11-1.916 0v-11.426a.958.958 0 111.916 0zm4.018 0a.958.958 0 11-1.916 0v-11.426a.958.958 0 111.916 0z",
  transform: "translate(-1282.441 -192.116)",
  fill: "#98c3d9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_82",
  className: "top",
  "data-name": "Path 82",
  d: "M1300.962 197.253l-2.586-2.767a1.641 1.641 0 00-1.2-.523h-6.527a1.642 1.642 0 00-1.2.523l-2.584 2.767h-2.3a1.646 1.646 0 00-1.646 1.646 1.646 1.646 0 001.646 1.646h18.709a1.646 1.646 0 001.646-1.646 1.646 1.646 0 00-1.646-1.646z",
  transform: "translate(-1282.916 -193.963)",
  fill: "#98c3d9"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_281",
  className: "stripes",
  "data-name": "Group 281",
  transform: "translate(5.025 11.695)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  className: "pipeline",
  "data-name": "Path 87",
  d: "M1294.7 204.075V215.5a.958.958 0 101.916 0v-11.425a.958.958 0 10-1.916 0z",
  transform: "translate(-1285.668 -203.117)",
  fill: "#002d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  className: "pipeline",
  "data-name": "Path 88",
  d: "M1290.776 204.075V215.5a.958.958 0 101.916 0v-11.425a.958.958 0 10-1.916 0z",
  transform: "translate(-1285.759 -203.117)",
  fill: "#002d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_89",
  className: "pipeline",
  "data-name": "Path 89",
  d: "M1286.849 204.075V215.5a.958.958 0 101.916 0v-11.425a.958.958 0 10-1.916 0z",
  transform: "translate(-1285.849 -203.117)",
  fill: "#002d56"
}));

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DeleteMid",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 29.752,
    viewBox: "0 0 22 29.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };